import { render, staticRenderFns } from "./SuperAdminUploadRow.vue?vue&type=template&id=4bc5f467&"
import script from "./SuperAdminUploadRow.vue?vue&type=script&lang=js&"
export * from "./SuperAdminUploadRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports